import { extendTheme, type ThemeConfig } from '@chakra-ui/react'
import { Box } from '@chakra-ui/layout';
// export { CardImage } from './Card/CardImage';
// export { Button } from './Button/Button';
// export {
//   Icon,
//   IconYouTubeLogo,
//   IconDiscordLogo,
//   IconInstagramLogo,
//   IconTwitterLogo,
//   IconFacebookLogo,
//   IconTwitchLogo,
//   IconHamburgerMenu,
//   CommonIcon,
//   RareIcon,
//   LegendaryIcon,
//   UltimateIcon,
//   IconInfo,
//   IconInfoOutline,
//   OwnedEditionLogo,
//   HiddenEditionLogo,
//   BurnedEditionLogo,
//   UnavailableEditionLogo,
//   IconBorn,
//   IconHometown,
//   IconDraft,
//   IconMaximize,
//   IconShare,
//   IconFootball,
//   IconDropsAnnouncement,
//   IconDropsMarket,
//   IconCheckmark,
//   IconChevronDown,
//   IconChevronLeft,
//   IconChevronRight,
//   IconCalendar,
//   IconClock,
//   IconClose,
//   IconGear,
//   IconAlert,
//   IconCheck,
//   IconTriangle,
//   IconRefresh,
//   IconPaginationArrowLeft,
//   IconPaginationArrowRight,
//   IconExternalLink,
//   ICON_ARROW_FORWARD,
//   ICON_CHEVRON_DOWN,
//   ICON_CHECK,
//   ICON_DOWNLOAD,
//   ICON_ATSIGN,
//   ICON_FILTER,
//   ICON_USER,
//   ICON_INSTAGRAM,
//   ICON_LINKEDIN,
//   ICON_TWITTER,
//   ICON_X,
//   ICON_HELP,
//   VolumeOn,
//   VolumeOff,
// } from './Icon';
// export type { Props as ButtonProps } from './Button/Button';
// export * from './Link';
// export type { LinkDeprecatedProps } from './Link/LinkDeprecated';
// export { TextDeprecated } from './TextDeprecated/TextDeprecated';
// export { HeadingDeprecated } from './HeadingDeprecated/HeadingDeprecated';
// export { NextImage } from './Image';
export { Link } from './Link';
export {
  Container,
  Flex,
  Grid,
  GridItem,
  Stack,
  VStack,
  HStack,
  StackDivider,
} from '@chakra-ui/layout';
export {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  AspectRatio,
  Avatar,
  AvatarGroup,
  Badge,
  Button,
  Box,
  Center,
  Checkbox,
  CloseButton,
  Code,
  Collapse,
  Divider,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Heading,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  keyframes,
  FormControl,
  FormLabel,
  Menu,
  MenuList,
  MenuItem,
  MenuButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Popover,
  PopoverTrigger,
  PopoverArrow,
  PopoverContent,
  PopoverCloseButton,
  PopoverHeader,
  PopoverBody,
  Select,
  Spacer,
  Spinner,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Table,
  Thead,
  Tbody,
  Tfoot,
  Th,
  Tr,
  Td,
  Tag,
  Text,
  Tooltip,
  List,
  ListItem,
  ListIcon,
  LinkBox,
  LinkOverlay,
  OrderedList,
  UnorderedList,
  useBoolean,
  useBreakpointValue,
  useDisclosure,
  useOutsideClick,
  useRadio,
  useRadioGroup,
  useTheme,
  useToast,
  MenuDivider,
  Radio,
  RadioGroup,
  SliderThumb,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SlideFade,
  Skeleton, SkeletonCircle, SkeletonText,
  IconButton,
  Wrap,
  WrapItem,
  useMultiStyleConfig,
  useStyles,
  useStyleConfig,
  VisuallyHidden,
} from '@chakra-ui/react';
export type { ResponsiveValue } from '@chakra-ui/react';

export type { HTMLChakraProps, ThemingProps } from '@chakra-ui/system';
export { chakra, omitThemingProps, StylesProvider } from '@chakra-ui/system';
export { cx } from '@chakra-ui/utils';

export { default as NextLink } from 'next/link';

export { useMediaQuery } from '@chakra-ui/media-query';

export type {
  BorderProps,
  CheckboxProps,
  GridProps,
  HeadingProps,
  LayoutProps,
  TextProps,
  IconProps,
  ImgProps,
  FlexProps,
  BoxProps,
  TagProps,
  ChakraTheme,
  ComponentStyleConfig,
} from '@chakra-ui/react';
export { forwardRef } from '@chakra-ui/react';

// export { breakpoints } from './theme';

// export { default as theme } from './theme';
// export { Fonts } from './Fonts/Fonts';

// export * from './Fonts/typeface';



// 2. Add your color mode config
const config = {
  initialColorMode: 'dark',
  useSystemColorMode: false,
}

// 3. extend the theme
const theme = extendTheme({ config })

export default theme
